import { TileCoordinates } from "./coordinates";
import { ChunkedData } from "../util/ChunkedData";
import lodash from "lodash";
import { Rectangle, Vector2 } from "../math";
import { TileArea } from "./coordinates/TileArea";
import { HostedMapCollisionData, TileCollisionData } from "./CollisionData";
export var PlayerPosition;
(function (PlayerPosition) {
    function eq(a, b) {
        return TileCoordinates.eq2(a.tile, b.tile) && a.direction == b.direction;
    }
    PlayerPosition.eq = eq;
})(PlayerPosition || (PlayerPosition = {}));
export var MovementAssumptions;
(function (MovementAssumptions) {
    function escapeRange(assumptions) {
        return assumptions.range_weapon_range != undefined ? assumptions.range_weapon_range - 1 : 7;
    }
    MovementAssumptions.escapeRange = escapeRange;
})(MovementAssumptions || (MovementAssumptions = {}));
export var direction;
(function (direction_1) {
    direction_1.cardinals = [1, 2, 3, 4];
    direction_1.ordinals = [5, 6, 7, 8];
    direction_1.all = [1, 2, 3, 4, 5, 6, 7, 8];
    const vectors = [
        { x: 0, y: 0 }, // 0 center
        { x: -1, y: 0 }, // 1 left
        { x: 0, y: 1 }, // 2 top
        { x: 1, y: 0 }, // 3 right
        { x: 0, y: -1 }, // 4 bottom
        { x: -1, y: 1 }, // 5 topleft
        { x: 1, y: 1 }, // 6 topright
        { x: 1, y: -1 }, // 7 botright
        { x: -1, y: -1 }, // 8 botleft
    ];
    function invert(d) {
        return [0, 3, 4, 1, 2, 7, 8, 5, 6][d];
    }
    direction_1.invert = invert;
    function isCardinal(dir) {
        return dir >= 1 && dir <= 4;
    }
    direction_1.isCardinal = isCardinal;
    function isOrdinal(dir) {
        return dir >= 5;
    }
    direction_1.isOrdinal = isOrdinal;
    function toVector(d) {
        return vectors[d];
    }
    direction_1.toVector = toVector;
    function fromDelta(v) {
        return [
            [8, 4, 7],
            [1, 0, 3],
            [5, 2, 6],
        ][v.y + 1][v.x + 1];
    }
    direction_1.fromDelta = fromDelta;
    function fromVector(v) {
        // There is most likely a better solution, but this is enough for now
        // It's an 23 by 23 box where real click are clamped into.
        const lookup_table = [
            [5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6],
            [5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6],
            [5, 5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6, 6],
            [5, 5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6, 6],
            [5, 5, 5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6, 6, 6],
            [5, 5, 5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6, 6, 6],
            [1, 5, 5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6, 6, 3],
            [1, 1, 5, 5, 5, 5, 5, 5, 5, 5, 2, 2, 2, 6, 6, 6, 6, 6, 6, 6, 6, 3, 3],
            [1, 1, 1, 1, 5, 5, 5, 5, 5, 5, 2, 2, 2, 6, 6, 6, 6, 6, 6, 3, 3, 3, 3],
            [1, 1, 1, 1, 1, 1, 1, 5, 5, 5, 5, 2, 6, 6, 6, 6, 3, 3, 3, 3, 3, 3, 3],
            [1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 5, 2, 6, 6, 3, 3, 3, 3, 3, 3, 3, 3, 3],
            [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
            [1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 4, 7, 7, 3, 3, 3, 3, 3, 3, 3, 3, 3],
            [1, 1, 1, 1, 1, 1, 1, 8, 8, 8, 8, 4, 7, 7, 7, 7, 3, 3, 3, 3, 3, 3, 3],
            [1, 1, 1, 1, 8, 8, 8, 8, 8, 8, 4, 4, 4, 7, 7, 7, 7, 7, 7, 3, 3, 3, 3],
            [1, 1, 8, 8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7, 7, 3, 3],
            [1, 8, 8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7, 7, 3],
            [8, 8, 8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7, 7, 7],
            [8, 8, 8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7, 7, 7],
            [8, 8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7, 7],
            [8, 8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7, 7],
            [8, 8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7, 7],
            [8, 8, 8, 8, 8, 8, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 7, 7, 7, 7, 7, 7],
        ];
        // TODO: Clamping probably isnt correct and also weird.
        // Clamp vector into bounds
        const v2 = Rectangle.clampInto(Vector2.snap(v), {
            topleft: { x: -11, y: 11 },
            botright: { x: 11, y: -11 },
        });
        if (!lookup_table[11 - v2.y])
            debugger;
        return lookup_table[11 - v2.y][v2.x + 11];
    }
    direction_1.fromVector = fromVector;
    function toString(dir) {
        return [
            "Center",
            "West",
            "North",
            "East",
            "South",
            "North-West",
            "North-East",
            "South-East",
            "South-West"
        ][dir];
    }
    direction_1.toString = toString;
    function toShortString(dir) {
        return [
            "C",
            "W",
            "N",
            "E",
            "S",
            "NW",
            "NE",
            "SE",
            "SW"
        ][dir];
    }
    direction_1.toShortString = toShortString;
    direction_1.center = 0;
    direction_1.west = 1;
    direction_1.north = 2;
    direction_1.east = 3;
    direction_1.south = 4;
    direction_1.northwest = 5;
    direction_1.northeast = 6;
    direction_1.southeast = 7;
    direction_1.southwest = 8;
    function transform(direction, transform) {
        return fromVector(Vector2.snap(Vector2.transform(toVector(direction), transform)));
    }
    direction_1.transform = transform;
    function split(dir) {
        return [
            [direction_1.north, direction_1.west],
            [direction_1.north, direction_1.east],
            [direction_1.south, direction_1.east],
            [direction_1.south, direction_1.west]
        ][dir - 5];
    }
    direction_1.split = split;
    function rotate(dir, quarters) {
        if (dir == direction_1.center)
            return direction_1.center;
        return (dir - 1 + quarters) % 4 + 1 + Math.floor(dir / 5) * 4;
    }
    direction_1.rotate = rotate;
    function continuations(dir) {
        const direction_continuations = [
            [],
            [direction_1.west],
            [direction_1.north],
            [direction_1.east],
            [direction_1.south],
            [direction_1.north, direction_1.west, direction_1.northwest],
            [direction_1.north, direction_1.east, direction_1.northeast],
            [direction_1.south, direction_1.east, direction_1.southeast],
            [direction_1.south, direction_1.west, direction_1.southwest]
        ];
        return direction_continuations[dir];
    }
    direction_1.continuations = continuations;
})(direction || (direction = {}));
export function move(pos, off) {
    return {
        x: pos.x + off.x,
        y: pos.y + off.y,
        level: pos.level
    };
}
export var PathFinder;
(function (PathFinder) {
    function init_djikstra(start, data = HostedMapCollisionData.get()) {
        let state = {
            data: data,
            start: start,
            tiles: new ChunkedData(),
            queue: [ChunkedData.split(start)],
            next: 0
        };
        state.tiles.set(state.queue[0], { parent: null });
        return state;
    }
    PathFinder.init_djikstra = init_djikstra;
    const movement_direction_priority = [
        direction.west, direction.east,
        direction.south, direction.north,
        direction.southwest, direction.southeast,
        direction.northwest, direction.northeast,
    ];
    async function djikstra2(state, target, step_limit) {
        // This is a typical djikstra algorithm
        // To improve it to A*, it still needs to prefer ortogonal pathing before diagonal pathing like ingame, but I'm not sure how to do that yet.
        // Possibly with a stable priority queue and tile distance as an estimator
        while (state.blocked) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        state.blocked = true;
        // Abstraction to push elements into the queue. Filters out of bounds tiles and tiles that already have a path
        function push(tile, parent) {
            let i = ChunkedData.split(tile);
            if (state.tiles.get(i) == null) {
                state.tiles.set(i, { parent: parent });
                state.queue.push(i);
            }
        }
        while (state.queue.length < step_limit && state.next < state.queue.length) {
            const e = state.queue[state.next++];
            const e_movement_data = await state.data.getTile(e.coords);
            for (let i of movement_direction_priority) {
                if (TileCollisionData.isFree(e_movement_data, i))
                    push(move(e.coords, direction.toVector(i)), e);
            }
            if (target(e.coords)) {
                state.blocked = false;
                return e.coords;
            }
        }
        state.blocked = false;
        return null;
    }
    function get(state, tile) {
        function helper(i) {
            let parent = state.tiles.get(i)?.parent;
            if (state.tiles.get(i)?.parent == null)
                return [i];
            let p = helper(parent);
            p.push(i);
            return p;
        }
        let p = helper(tile).map((c) => lodash.clone(c.coords));
        p.forEach(l => l.level = state.start.level);
        return cleanWaypoints(p);
    }
    async function find(state, target) {
        if (target.origin.level != state.start.level)
            return null;
        // Check if the target tile can be reached from any of its direct neighbours
        // If not, do not even search for a path.
        if (TileArea.isSingleTile(target)) {
            const target_i = ChunkedData.split(target.origin);
            const reachable_at_all = state.data.isAccessible(target.origin);
            if (!reachable_at_all) {
                state.tiles.set(target_i, { parent: null, unreachable: true });
                return null;
            }
        }
        const target_area = TileArea.activate(target);
        // Check for existing routes to any tile inside the area
        {
            let size = target_area.size;
            for (let delta_x = 0; delta_x < size.x; delta_x++) {
                for (let delta_y = 0; delta_y < size.y; delta_y++) {
                    const tile = { x: target.origin.x + delta_x, y: target.origin.y + delta_y, level: target.origin.level };
                    if (target_area.query(tile)) {
                        let target_i = ChunkedData.split(tile);
                        // Check the cache for existing result
                        let existing = state.tiles.get(target_i);
                        if (existing != null) {
                            if (existing.unreachable)
                                return null;
                            else
                                return get(state, target_i);
                        }
                    }
                }
            }
        }
        let end_tile = await djikstra2(state, (tile) => {
            // return TileCoordinates.eq2(target_area.origin, tile)
            return target_area.query(tile);
        }, 5000);
        // Cache whether the target is unreachable to prevent endless search
        if (!end_tile) {
            let size = TileArea.size(target);
            for (let delta_x = 0; delta_x < size.x; delta_x++) {
                for (let delta_y = 0; delta_y < size.y; delta_y++) {
                    const tile = { x: target.origin.x + delta_x, y: target.origin.y + delta_y, level: target.origin.level };
                    if (target_area.query(tile)) {
                        state.tiles.set(ChunkedData.split(tile), { parent: null, unreachable: true });
                    }
                }
            }
            return null;
        }
        return get(state, ChunkedData.split(end_tile));
    }
    PathFinder.find = find;
    function idealPath(from, to) {
        if (from.level != to.level)
            return null;
        let delta = Vector2.sub(to, from);
        let abs_delta = Vector2.abs(delta);
        let checkpoint = Vector2.add(from, abs_delta.x >= abs_delta.y
            ? { x: Math.sign(delta.x) * (abs_delta.x - abs_delta.y), y: 0 }
            : { x: 0, y: Math.sign(delta.y) * (abs_delta.y - abs_delta.x) });
        return [from, TileCoordinates.lift(checkpoint, from.level), to];
    }
    PathFinder.idealPath = idealPath;
    function cleanWaypoints(s) {
        let new_waypoints = [];
        let last_dir = direction.center;
        let last_non_committed = s[0];
        for (let i = 1; i < s.length; i++) {
            let dir = direction.fromDelta(Vector2.sign(Vector2.sub(s[i], last_non_committed)));
            if (dir != last_dir) {
                new_waypoints.push(last_non_committed);
                last_non_committed = s[i];
                last_dir = dir;
            }
            last_non_committed = s[i];
        }
        new_waypoints.push(last_non_committed);
        return new_waypoints;
    }
    PathFinder.cleanWaypoints = cleanWaypoints;
    function pathLength(s) {
        let distance = 0;
        for (let i = 0; i < s.length - 1; i++) {
            distance += TileCoordinates.distance(s[i], s[i + 1]);
        }
        return distance;
    }
    PathFinder.pathLength = pathLength;
})(PathFinder || (PathFinder = {}));
export var MovementAbilities;
(function (MovementAbilities) {
    /*
    type r = {
        origin: TileCoordinates,
        raster: Raster<{
            reachable?: boolean
        }>
    }*/
    async function possibility_raster(collision, assumptions, origin, surge_escape_for = []) {
        const range = 10;
        const raster = TileArea.activate(TileArea.init(TileCoordinates.move(origin, { x: -range, y: -range }), { x: 21, y: 21 }, false));
        async function handle(actor) {
            raster.set(actor.position, true);
            const actor_tile_movement_data = await collision.getTile(actor.position);
            const delta = Vector2.abs(Vector2.sub(actor.position, origin));
            const movement_in_range = {
                x: delta.x < range,
                y: delta.y < range
            };
            // TODO: Potentially replace direct recursions with loops
            if (direction.isCardinal(actor.movement)) {
                if (movement_in_range.y && movement_in_range.x && TileCollisionData.isFree(actor_tile_movement_data, actor.movement)) {
                    await handle({
                        position: TileCoordinates.move(actor.position, direction.toVector(actor.movement)),
                        movement: actor.movement
                    });
                }
            }
            else {
                let [north_south, east_west] = direction.split(actor.movement);
                if (movement_in_range.x && movement_in_range.y && TileCollisionData.isFree(actor_tile_movement_data, actor.movement)) {
                    await handle({
                        position: TileCoordinates.move(actor.position, direction.toVector(actor.movement)),
                        movement: actor.movement
                    });
                    // Create vertical mirror actor
                    if (TileCollisionData.isFree(actor_tile_movement_data, north_south)) {
                        await handle({
                            position: TileCoordinates.move(actor.position, direction.toVector(north_south)),
                            movement: north_south
                        });
                    }
                    // Create horizontal mirror actor
                    if (TileCollisionData.isFree(actor_tile_movement_data, east_west)) {
                        await handle({
                            position: TileCoordinates.move(actor.position, direction.toVector(east_west)),
                            movement: east_west
                        });
                    }
                }
                else if (movement_in_range.x && TileCollisionData.isFree(actor_tile_movement_data, east_west)) {
                    await handle({
                        position: TileCoordinates.move(actor.position, direction.toVector(east_west)),
                        movement: actor.movement
                    });
                    // Create vertical mirror actor
                    if (TileCollisionData.isFree(actor_tile_movement_data, north_south)) {
                        await handle({
                            position: TileCoordinates.move(actor.position, direction.toVector(north_south)),
                            movement: north_south
                        });
                    }
                }
                else if (movement_in_range.y && TileCollisionData.isFree(actor_tile_movement_data, north_south)) {
                    await handle({
                        position: TileCoordinates.move(actor.position, direction.toVector(north_south)),
                        movement: actor.movement
                    });
                }
            }
        }
        for (let dir of direction.ordinals) {
            await handle({
                position: origin,
                movement: dir
            });
        }
        function findFurthest(dir, max_distance) {
            if (max_distance == 0)
                return origin;
            const current = TileCoordinates.move(origin, Vector2.scale(max_distance, direction.toVector(dir)));
            if (raster.query(current))
                return current;
            else
                return findFurthest(dir, max_distance - 1);
        }
        return {
            targets: surge_escape_for.map(dir => {
                return {
                    direction: dir,
                    surge: findFurthest(dir, 10),
                    escape: findFurthest(direction.invert(dir), MovementAssumptions.escapeRange(assumptions))
                };
            }),
            data: raster
        };
    }
    MovementAbilities.possibility_raster = possibility_raster;
    async function dive_internal(data, position, target) {
        // This function does not respect any max distances and expects the caller to handle that.
        if (position.level != target.level)
            return null;
        let dia = Vector2.sign(Vector2.sub(target, position));
        let bound = Rectangle.from(position, target);
        let choices = [];
        /* Repeat until tile found or out of bounds, only consider if not out of bounds:
            1. Move towards the target tile diagonally. Only if diagonal walk is permitted.
            (E.g. in an attempt to move 1 tile north-east, you actually move 1 tile east, then north due to a wall = doesn't count.)
            2. Move towards the target tile on X-axis.
            3. Move towards the target tile on Y-axis.
         */
        if (dia.x != 0 && dia.y != 0)
            choices.push({ delta: dia, dir: direction.fromDelta(dia) });
        if (dia.x != 0)
            choices.push({ delta: { x: dia.x, y: 0 }, dir: direction.fromDelta({ x: dia.x, y: 0 }) });
        if (dia.y != 0)
            choices.push({ delta: { x: 0, y: dia.y }, dir: direction.fromDelta({ x: 0, y: dia.y }) });
        while (true) {
            if (Vector2.eq(position, target))
                return {
                    tile: position,
                    direction: direction.fromVector(Vector2.sub(target, position))
                };
            const movement_data = await data.getTile(position);
            let next = null;
            for (let choice of choices) {
                const candidate = move(position, choice.delta);
                if (Rectangle.containsTile(bound, candidate) && TileCollisionData.isFree(movement_data, choice.dir)) {
                    next = candidate;
                    break;
                }
            }
            if (!next)
                return null;
            position = next;
        }
    }
    MovementAbilities.dive_internal = dive_internal;
    async function dive_far_internal(data, start, dir, max_distance) {
        let d = direction.toVector(dir);
        /*
            If clicked more than max distance:
            Check each tile, take the maximum
         */
        // Is there a way to optimize this so not every tile has to be checked?
        for (let i = max_distance; i > 0; i--) {
            let t = await dive_internal(data, start, move(start, Vector2.scale(i, d)));
            if (t)
                return t;
        }
        return null;
    }
    MovementAbilities.dive_far_internal = dive_far_internal;
    async function dive(position, target, data = HostedMapCollisionData.get()) {
        const delta = Vector2.sub(target, position);
        if (Vector2.max_axis(delta) > 10) {
            let dir = direction.fromVector(delta);
            // This ignores the fact that dive is always consumed, even if diving a distance of 0 tiles.
            return await dive_far_internal(data, position, dir, 10);
        }
        else
            return dive_internal(data, position, target);
    }
    MovementAbilities.dive = dive;
    async function barge(position, target, data = HostedMapCollisionData.get()) {
        return dive(position, target, data); // Barge is the same logic as dive
    }
    MovementAbilities.barge = barge;
    async function surge(position, data = HostedMapCollisionData.get()) {
        return dive_far_internal(data, position.tile, position.direction, 10);
    }
    MovementAbilities.surge = surge;
    async function escape(position, distance, data = HostedMapCollisionData.get()) {
        let res = await dive_far_internal(data, position.tile, direction.invert(position.direction), distance);
        if (!res)
            return null;
        else
            return {
                tile: res.tile,
                direction: position.direction
            };
    }
    MovementAbilities.escape = escape;
    async function generic(data, ability, assumptions, position, target) {
        switch (ability) {
            case "surge":
                return surge({ tile: position, direction: direction.fromVector(Vector2.sub(target, position)) }, data);
            case "dive":
                return dive(position, target, data);
            case "escape":
                return escape({ tile: position, direction: direction.fromVector(Vector2.sub(position, target)) }, MovementAssumptions.escapeRange(assumptions), data);
            case "barge":
                return barge(position, target, data);
        }
    }
    MovementAbilities.generic = generic;
    function cooldown(ability, powerburst, mobile) {
        switch (ability) {
            case "surge":
                return (powerburst ? 2 : (mobile ? 17 : 34));
            case "dive":
                return (powerburst ? 2 : (mobile ? 17 : 34));
            case "escape":
                return mobile ? 17 : 34; // Powerburst does not affect escape
            case "barge":
                return 34;
        }
    }
    MovementAbilities.cooldown = cooldown;
    async function isFarDive(from, to) {
        const offset = Vector2.sub(to, from);
        if (offset.y != 0 && offset.x != 0 && Math.abs(offset.x) != Math.abs(offset.y))
            return false;
        const dist = Vector2.max_axis(offset);
        if (dist == 10 && (offset.y == 0 || offset.x == 0 || Math.abs(offset.x) == Math.abs(offset.y)))
            return true;
        const dir = direction.fromVector(offset);
        const far_target = (await dive_far_internal(HostedMapCollisionData.get(), from, dir, 10))?.tile;
        return TileCoordinates.equals(far_target, to);
    }
    MovementAbilities.isFarDive = isFarDive;
})(MovementAbilities || (MovementAbilities = {}));
